"use strict";
var BaseFieldConfig = (function () {
    function BaseFieldConfig() {
    }
    return BaseFieldConfig;
}());
exports.BaseFieldConfig = BaseFieldConfig;



// WEBPACK FOOTER //
// ./~/@bhtp-client-web/component/src/view-config-models/base-field-config.model.js